import { useCallback } from 'react';

import { IMenuItem } from 'types/menu';

export const useFlattenRoutes = () => {
  const flatten = (routes: IMenuItem[]) => {
    return routes.reduce((current, previous): IMenuItem[] => {
      const { children, includeInMenu } = previous;

      if (includeInMenu) {
        return [...current, previous];
      } else {
        return [...current, ...flatten(children ?? [])];
      }
    }, [] as IMenuItem[]);
  };

  return useCallback(flatten, [flatten]);
};
